import dayjs from './dayjs'

// Eski `utils/fliter.js` şablon filtreleri buraya taşındı: Vue 3'te `{{ x | f }}` yok,
// bu fonksiyonlar `$dateFormat(x)` gibi global property olarak çağrılır.
// Gövdeler Lite'ın `fliter.js`'inden BİREBİR alındı (Estesoft.App'in gövdeleri farklıdır);
// yalnız moment çağrıları dayjs oldu. Tek fark kullanılmayan `formatDate`'te: göreli zaman
// artık dayjs'in global yerel ayarıyla (tr) yazılır, moment'ta en idi.
export const formatters = {
  reverse: function (value) {
  // slice to make a copy of array, then reverse the copy
  return value.slice().reverse()
},

  formatDate: function (value) {
  if (value) {
    return dayjs(String(value)).fromNow()
  }
},

  dateFormat: function (value) {
  if (!value) return ''
  return dayjs(String(value)).format('DD.MM.YYYY')
},

  dateFormatWithHourForContainingT: function (value) {
  if (value && value.indexOf("T") != -1) {
    var splittedDateArray = value.split("T")[0].split("-");

    var splittedTimeArray = "";

    if (value.split("T")[1].indexOf("+") != -1)
      splittedTimeArray = value.split("T")[1].split("+");
    else if (value.split("T")[1].indexOf("-") != -1)
      splittedTimeArray = value.split("T")[1].split("-");
    else
      splittedTimeArray = value.split("T")[1];

    if (splittedDateArray.length > 0 && splittedTimeArray.length > 0) {
      return splittedDateArray[2] + "." + splittedDateArray[1] + "." + splittedDateArray[0] + ' ' + splittedTimeArray[0].slice(0, -3);
    }
    else
      return value;
  }
  else {
    return value;
  }
}
};

// Vue 2 (`Vue.use`) ve Vue 3 (`app.use`) ile aynı şekilde çalışır:
// Vue 2'de `Vue.prototype`, Vue 3'te `app.config.globalProperties` hedeflenir.
export default {
  install(app) {
    const target = app.config && app.config.globalProperties
      ? app.config.globalProperties
      : app.prototype;

    Object.keys(formatters).forEach(name => {
      target['$' + name] = formatters[name];
    });
  }
};
